import { render, staticRenderFns } from "./lab_test_reports.vue?vue&type=template&id=c39adbae&scoped=true&"
import script from "./lab_test_reports.vue?vue&type=script&lang=js&"
export * from "./lab_test_reports.vue?vue&type=script&lang=js&"
import style0 from "./lab_test_reports.vue?vue&type=style&index=0&id=c39adbae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39adbae",
  null
  
)

export default component.exports